import {
  IsVaultDeletableApi,
  ListVaultAccountsApi,
  type Configuration,
  VaultsApi,
  type CreateVaultRequest,
} from '@repo/api-gw-sdk';

import type { BackupVault } from '@/data/vaults/backupVault';

import type { HttpClient } from './httpClient';

const baseUrl = '/vaults';

export const vaults = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const vaultsApi = new VaultsApi(config);
  const listVaultAccountsApi = new ListVaultAccountsApi(config);
  const isVaultDeletableApi = new IsVaultDeletableApi(config);
  return {
    useList: () =>
      httpClient.execute(
        vaultsApi.listVaults.bind(vaultsApi),
        baseUrl,
        '/vaults',
        currentProjectId,
        undefined,
        undefined
      ),
    create: (vault: BackupVault) => {
      // Convert BackupVault to CreateBackupVaultInput
      const createInput: CreateVaultRequest = {
        name: vault.name,
        vaultAccountId: vault.vaultAccountId,
        region: vault.region,
        vaultAttributes: {
          cloudProvider: vault.vaultAttributes.cloudProvider,
          aws: {
            encryptionKey: vault.vaultAttributes.aws?.encryptionKey,
            mrapAlias: vault.vaultAttributes.aws?.mrapAlias,
          },
          azure: {
            tenantId: vault.vaultAttributes.azure?.tenantId,
            encryptionKey: vault.vaultAttributes.azure?.encryptionKey,
            cmkKeyVaultTenantId:
              vault.vaultAttributes.azure?.cmkKeyVaultTenantId,
            cmkAppRegistrationId:
              vault.vaultAttributes.azure?.cmkAppRegistrationId,
          },
          gcp: {
            encryptionKey: vault.vaultAttributes.gcp?.encryptionKey,
          },
        },
        bucketName: vault.vaultAttributes.aws?.bucketName || undefined,
      };

      return vaultsApi.createVault(currentProjectId, createInput);
    },
    useListAzureCmkEligibleApps: (
      vaultAccountId: string,
      customerTenantId: string | undefined
    ) =>
      httpClient.execute(
        vaultsApi.listAzureCmkEligibleApps.bind(vaultsApi),
        !vaultAccountId || !customerTenantId ? null : baseUrl,
        '/azure-cmk-eligible-apps',
        currentProjectId,
        vaultAccountId,
        customerTenantId ?? ''
      ),
    update: (vault: BackupVault) =>
      vaultsApi.updateVault(currentProjectId, vault.id, {
        name: vault.name,
      }),
    delete: (vaultId: string) =>
      vaultsApi.deleteVault(currentProjectId, vaultId),
    useAccounts: () =>
      httpClient.execute(
        listVaultAccountsApi.listVaultAccounts.bind(listVaultAccountsApi),
        baseUrl,
        'vault-accounts'
      ),
    isVaultDeletable: (vaultId: string) =>
      isVaultDeletableApi.isVaultDeletable(currentProjectId, vaultId),
  };
};
